import React from 'react';

import { UnderlineAnimated as StyledUnderlineAnimated } from './styles';

const UnderlineAnimated = ({ children, showUnderline }) => (
  <StyledUnderlineAnimated data-underline={showUnderline}>{children}</StyledUnderlineAnimated>
);

export default UnderlineAnimated;
